// SecretCodeTopTimer.jsx
import React, { useEffect, useRef, useState } from 'react';

const SecretCodeTopTimer = ({ onDecrypted, onTopTimerFinish }) => {
  const [remainingTime, setRemainingTime] = useState(0);
  const [visible, setVisible] = useState(false);
  const topTimerRef = useRef(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let payload = urlParams.get('redirect');
    if (!payload) return;

    payload = decodeURIComponent(payload)
      .replace(/\s/g, '+')
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    payload += '='.repeat((4 - (payload.length % 4)) % 4);

    const secretKey = '1234567890123456';
    const binary = Uint8Array.from(atob(payload), c => c.charCodeAt(0));
    const iv = binary.slice(0, 16);
    const data = binary.slice(16);

    crypto.subtle.importKey('raw', new TextEncoder().encode(secretKey), 'AES-CBC', false, ['decrypt'])
      .then(key =>
        crypto.subtle.decrypt({ name: 'AES-CBC', iv }, key, data)
      )
      .then(decrypted => {
        const code = new TextDecoder().decode(decrypted);
        onDecrypted(code);
        setVisible(true);
        startTimer();
      })
      .catch(() => console.warn('Invalid or missing redirect'));
  }, []);

  const startTimer = () => {
    const countdown = Math.floor(Math.random() * 51) + 15;
    setRemainingTime(countdown);
    topTimerRef.current = setInterval(() => {
      setRemainingTime(prev => {
        if (prev <= 1) {
          clearInterval(topTimerRef.current);
          setVisible(false);
          onTopTimerFinish();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  if (!visible) return null;

  return (
    <section className="top-section">
      <div className="timer">{remainingTime}</div>
    </section>
  );
};

export default SecretCodeTopTimer;
